import { atom } from 'nanostores';

export interface Undoable {
  undo(): void;
  redo(): void;
  description: string;
}

export class UndoManager {
  private undoStack: Undoable[] = [];
  private redoStack: Undoable[] = [];
  public undoDesc = atom<string | null>(null);
  public redoDesc = atom<string | null>(null);

  startTransaction(initialUndo: () => void) {
    let completed = false;

    return {
      commit: (redo: () => void, description: string) => {
        if (completed) return;
        completed = true;
        this.push({ undo: initialUndo, redo, description });
      },
      cancel: () => {
        if (completed) return;
        completed = true;
        initialUndo(); // Rollback to initial state
      },
    };
  }

  top(): Undoable | undefined {
    return this.undoStack[this.undoStack.length - 1];
  }

  topRedo(): Undoable | undefined {
    return this.redoStack[this.redoStack.length - 1];
  }

  push(undoable: Undoable): void {
    this.undoStack.push(undoable);
    this.redoStack = [];
    this.updateAtoms();
  }

  undo(): void {
    const undoable = this.undoStack.pop();
    if (undoable) {
      undoable.undo();
      this.redoStack.push(undoable);
    }
    this.updateAtoms();
  }

  redo(): void {
    const undoable = this.redoStack.pop();
    if (undoable) {
      undoable.redo();
      this.undoStack.push(undoable);
    }
    this.updateAtoms();
  }

  private updateAtoms(): void {
    this.undoDesc.set(this.top()?.description ?? null);
    this.redoDesc.set(this.topRedo()?.description ?? null);
  }
}
